export const firstNonEmptyString = (...values: (string | null | undefined)[]): string => {
    for (const value of values) {
        if (typeof value === 'string' && value !== '') return value;
    }
    return '';
};
